import { Injectable } from '@angular/core';
import { DynamicSchemaFacade } from './dynamic-schema/dynamic-schema.facade';
import { SchemasFactory, Schema } from '../squidex';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class DynamicSchemaFactory {

  constructor(
    public readonly schemasFactory: SchemasFactory,
    private readonly translateService: TranslateService) { }

  getDynamicSchemaFacade(schemaName: string): DynamicSchemaFacade {
    return new DynamicSchemaFacade(schemaName, this.schemasFactory, this.translateService);
  }

  hardDeleteSchema(id: string): Promise<void|Object> {
    return this.schemasFactory.hardDeleteSchema(id).then(d => {
      this.schemasFactory.reloadSchemas = true;
    });
  }

  getAllSchemaMetaData(): Observable<Schema[]> {
    return this.schemasFactory.getAllSchemas();
  }

  getSchemasMetadataByCategory(category: string): Observable<Schema[]> {
    return this.schemasFactory.getAllSchemas()
      .pipe(
        map(schemas => schemas.filter(schema => schema.category === category))
    );
  }
}
